import React, { FC } from "react";
import { Typography } from "../../../Fundamentals/Typography/Typography";
import { IBrandWallItemProps } from "../../../Navigational/BrandWall/BrandWallItem.interface";
import MediaBuilder from "../../../Utility/MediaBuilder/MediaBuilder";
import { Link } from "../../Link";

export const BrandSlide: FC<IBrandWallItemProps> = ({
  title,
  mediaData,
  link,
  ...linkProps
}) => {
  return (
    <Link
      {...linkProps}
      href={link.href}
      classes={{ root: "text-decoration-none text-color-blue" }}
    >
      <>
        <div className="border-widget d-flex justify-content-center align-items-center text-color-black p-9">
          <div className="w-128px h-128px d-flex justify-content-center align-items-center">
            <MediaBuilder
              {...mediaData}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
        <div className="py-5 px-6 bg-color-grey-100">
          <Typography variant="h3-pdp" classes={{ root: "mb-0" }}>
            {title}
          </Typography>
        </div>
      </>
    </Link>
  );
};
